import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children, loggedIn }) => {
  return loggedIn == 1 ? children : loggedIn == 3 ? <Navigate to="/" /> : undefined;
};

export default PrivateRoute;
